import {
  GET_FINANCE_RESTAURANTS,
  GET_SEARCH_FINANCE_RESTAURANTS,
  DOWNLOAD_FINACE_RESTAURANTS
} from "../actions/financeRestaurants";
export default function(state = {}, action) {
  switch (action.type) {
    case GET_FINANCE_RESTAURANTS:
      return { ...state, ...action.payload };
    case GET_SEARCH_FINANCE_RESTAURANTS:
      return { ...state, ...action.payload };
    case DOWNLOAD_FINACE_RESTAURANTS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/financeRestaurants.js